export const DOMAIN_FOLDER = 'domain-folder';

const isFolder = (item: any): boolean => item?.isFolder || item?.type === 'folder';

export const isDomainFolder = (item: any): boolean => isFolder(item) && item.kind === DOMAIN_FOLDER;
export const isMountedFolder = (item: any): boolean => isFolder(item) && item.kind === 'mounted';
export const isSharedFolder = (item: any): boolean => isFolder(item) && item.kind === 'shared';
export const isPublicFolder = (item: any): boolean => isFolder(item) && Boolean(item.weblink);
export const isCameraUploadsFolder = (item: any): boolean => isFolder(item) && item?.kind === 'camera-upload';
export const isFamilyFolder = (item: any): boolean => isFolder(item) && item?.kind === 'family';
// restricted-папку нельзя перемещать, переименовывать, шарить на пользователей (маунтить), открывать для семьи
export const isRestrictedFolder = (item: any): boolean => isFolder(item) && item?.kind === 'restricted';
export const isAutodeleteFolder = (item: any): boolean => isFolder(item) && item?.weblinkExpires;
